/**
 * コードポイント単位の文字列操作。
 *
 * `String.prototype.length` は UTF-16 コード単位で数えるため、サロゲートペア（「𠮷」や絵文字）で
 * バックエンドの `mb_strlen` と値がずれる。クイズの正解文字数（`answerLength`）と突き合わせる処理は
 * 必ずこちらを使う（#2591）。
 */

/** コードポイント単位で 1 文字ずつに分割する */
export function splitCodePoints(value: string): string[] {
  return Array.from(value)
}

/** コードポイント単位の文字数（`mb_strlen` と同じ数え方） */
export function countCodePoints(value: string): number {
  return splitCodePoints(value).length
}

/** コードポイント単位で先頭 `length` 文字に切り詰める */
export function truncateCodePoints(value: string, length: number): string {
  return splitCodePoints(value).slice(0, length).join('')
}
